import React from 'react';

import { Button } from '@sequencing/design-system';
import ArrowCircle from '../../../../images/ArrowCircle.svg';
import { dateDiff } from '../../../../utilities/dateDiff';
import CountdownTimer from '../../../02-molecules/CountdownTimer/CountdownTimer';

import './DnaDayHolidayBanner.css';

const now = new Date();
const firstDeadline = new Date(2025, 3, 25, 23, 59, 59);
const recurrentDeadline = new Date(
  now.getFullYear(),
  now.getMonth(),
  now.getDate(),
  23,
  59,
  59
);

const deadline = now >= firstDeadline ? recurrentDeadline : firstDeadline;

const DnaDayHolidayBanner = () => {
  const dateDifference = dateDiff(deadline, now);

  const startTime = {
    days: dateDifference.days,
    hours: dateDifference.hours,
    minutes: dateDifference.minutes,
    seconds: dateDifference.seconds,
  };
  return (
    <a
      className="link"
      href="http://get.sequencing.com/dna-day-2025/?utm_source=website&utm_medium=top-banner&utm_campaign=dnaday&utm_content=t"
    >
      <div className={`dnaDayHolidayBanner`}>
        <div>
          <CountdownTimer startTime={startTime} />
        </div>
        <div className={`dnaDayHolidayBannerContent`}>
          <span>DNA DAY SPECIAL SALE!</span>
          {` `}
          <span>65% Off + Free Shipping</span>
        </div>
        <div className={`dnaDayHolidayBannerAction`}>
          <Button label={`Order Now`} variant={`outlinedWhite`} />
          <img alt={``} height={24} src={ArrowCircle} width={24} />
        </div>
      </div>
    </a>
  );
};

export default DnaDayHolidayBanner;
